import PropTypes from 'prop-types';
import { Component } from 'react';
import cn from 'classnames';

import BrIcons from '@components/BrIcons';
import BrText from '@components/BrText';
import './brOverlayModal.scss';

export default class BrOverlayModal extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    className: PropTypes.string,
    title: PropTypes.node,
    isDisplayed: PropTypes.bool.isRequired,
    warningMessage: PropTypes.any,
    controlButtons: PropTypes.arrayOf(PropTypes.any),
    onClickShadow: PropTypes.func, // subsequent behavior will only be active if func provided
    onClickNavClose: PropTypes.func, // subsequent behavior will only be active if func provided
  };

  shouldComponentUpdate(nextProps) {
    // doesn't prevent child from re-render if their state changed
    if (
      nextProps.children !== this.props.children
      || nextProps.isDisplayed !== this.props.isDisplayed
      || nextProps.title !== this.props.title
    ) {
      return true;
    }
    return false; // must return true or false if used
  }

  stopEventPropagation(e) {
    e.stopPropagation();
  }

  handleClickShadow = (e) => {
    const { onClickShadow } = this.props;
    if (onClickShadow) {
      onClickShadow(e);
    }
  };

  render() {
    const { children, className, isDisplayed, title, warningMessage, controlButtons, onClickNavClose } = this.props;

    const classname = cn('br-overlay-modal', className, {
      hidden: !isDisplayed,
    });
    return (
      <div className={classname} onClick={this.handleClickShadow} data-id="br-overlay-modal">
        <div className="br-overlay-modal-content" onClick={this.stopEventPropagation}>
          <div className="br-overlay-modal-title-nav">
            <div>
              <BrText>{title}</BrText>
            </div>
            {onClickNavClose ? (
              <div onClick={onClickNavClose}>
                <BrIcons.Cross isSubComp />
              </div>
            ) : null}
          </div>
          {warningMessage ? <div className="br-overlay-modal-warning">{warningMessage}</div> : null}
          <div className="br-overlay-modal-content-body">{children}</div>
          {controlButtons ? <div className="br-overlay-modal-control-nav">{controlButtons}</div> : null}
        </div>
      </div>
    );
  }
}
